<!--
 * @Author: your name
 * @Date: 2021-08-10 17:13:36
 * @LastEditTime: 2021-08-19 17:08:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /complement-data-record-client/src/components/login.vue
-->
<template>
  <div class="login-container" id="login-con">
    <div class="bac-img">
      <img src="https://cyinimg.cyipp.com/images/1/20210818171917000001" />
    </div>
    <div class="login-bg-header">
      <img src="./../assets/slice-logo-biack.svg" />
    </div>
    <div class="content">
      <el-card class="box-card">
        <h1 class="header">
          社交网站信息采集预览
        </h1>
        <el-form :model="loginForm" status-icon ref="loginForm" label-width="100px">
          <el-form-item label="账户名：" prop="username">
            <el-input
              type="text"
              v-model="loginForm.username"
              placeholder="请输入账户名"
              autocomplete="off"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="checkPass">
            <el-input
              type="password"
              v-model="loginForm.password"
              placeholder="请输入密码"
              autocomplete="off"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="primary" size="medium" @click="handleSubmit('ruleForm')">登录</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="login-bg-footer">
      <img src="https://cyinimg.cyipp.com/images/1/20210818171852000001" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from 'js-cookie'

function  setToken (token) {
  Cookies.set('auth-token', token, {
     expires: 3
  })
}

export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      }
    };
  },

  methods: {
    // 登录
    handleSubmit() {
      let params = {
        account: this.loginForm.username.trim(),
        password: this.loginForm.password
      };
      axios
          .post(
              '/api/omsLogin',
              params
          )
          .then((content) => {
            if (content.data.status.code == 0) {
              setToken(content.data.result.authToken);
              this.$router.push({
                path: '/',
              })
            }
          });
    }
  }
};
</script>
<style scoped>
.header {
  display: flex;
  justify-content: center;
  align-items: center;
}
.header .el-tag {
  margin-left: 16px;
  cursor: pointer;
}

.login-container {
  height: 100%;
  width: 100%;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  position: relative;
  overflow: hidden;
  background-color: #f5f6f8;
}
.bac-img {
  width: 100%;
  height: 100%;
}
.bac-img img {
  width: 100%;
  height: inherit;
}
.login-bg-header {
  position: absolute;
  top: 20px;
  left: 20px;
}
.login-bg-header img {
  height: 36px;
  width: auto;
}
.content {
  position: absolute;
  min-width: 400px;
  left: 14%;
}
.login-bg-footer {
  width: 260px;
  height: 90px;
  position: absolute;
  bottom: 0;
  left: 0;
}
.login-bg-footer img {
  width: 100%;
}
</style>


